import { numberAndUnit } from "../../infra/utils";
import { AmendmentsApprovalMethodType } from "./model";
export function isAutoApproval(amendmentsApprovalMethod) {
  return amendmentsApprovalMethod.type === AmendmentsApprovalMethodType.Auto;
}
export function noticePeriodDays(amendmentsApprovalMethod) {
  return isAutoApproval(amendmentsApprovalMethod) ? amendmentsApprovalMethod.auto.noticePeriodDays : null;
}
export function isEqual(a, b) {
  return isAutoApproval(a) === isAutoApproval(b) && noticePeriodDays(a) === noticePeriodDays(b);
}
export function description(amendmentsApprovalMethod) {
  return isAutoApproval(amendmentsApprovalMethod) ? "You will be notified of any updates via email. Changes will be automatically accepted after ".concat(numberAndUnit(amendmentsApprovalMethod.auto.noticePeriodDays, 'day'), " unless declined in Anchor.") : 'Any change to the agreement will require your approval.';
}